import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Users = ({ children }) => {
  const Navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/admin/lusers") {
      Navigate("/admin/lusers/user-tables");
    }
  }, [location, Navigate]);
  return (
    <div className="ml-2">
      <section>
        <div className="container">
          <div className="row">
            {children}
            {/* Add your store management components here */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Users;
